import NotificationSettingsTable from './NotificationSettingsTable';

export default NotificationSettingsTable;
